export default __webpack_public_path__ + "static/media/marke_5.8c2dbf6a.png";